// New tagged slice for the migrated `_features/plans` feature - consolidates
// TWO conflicting injectEndpoints calls that both existed on the same
// apiSlice for /plan routes:
//
// - the old `features/api/planApiSlice.js` (since removed entirely) -
//   matched the real backend (verified directly against
//   simplifyserver/routes/plan.js +
//   controllers/plan.controller.js: editPlan/archivePlan take the id in
//   the request body via `req.body._id`, not a URL param).
// - features/PlanFeature/api/planApi.js - WRONG routes (`PUT
//   /plan/archive/${id}`, `PUT /plan/${id}` - neither exists on the
//   backend). PlanPage.js's archive action used this one, so archiving a
//   plan 404'd in production - a real, live bug this consolidation fixes.
//
// Drops the dead `createPlan`/`deletePlan` endpoints (createPlan's only
// consumer was the unreachable PlanFormModal; deletePlan had zero
// consumers anywhere).
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const planApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    initiatePlan: builder.mutation({
      query: (data) => ({
        url: apiRoutes.plan.initiate.path,
        method: apiRoutes.plan.initiate.reqType,
        body: data,
      }),
      invalidatesTags: ["Plans"],
    }),
    getAllPlan: builder.query({
      query: (params) => ({
        url: apiRoutes.plan.get.path,
        method: apiRoutes.plan.get.reqType,
        params,
      }),
      providesTags: ["Plans"],
    }),
    getAllPlanByOrgId: builder.query({
      query: (params) => ({
        url: "/plan/all",
        method: "GET",
        params,
      }),
      providesTags: ["Plans"],
    }),
    getPlanById: builder.query({
      query: (id) => ({
        url: `/plan/${id}`,
        method: "GET",
      }),
      providesTags: ["Plans"],
    }),
    // Own tag (not "Plans") so a create/edit/archive elsewhere doesn't
    // force-refetch this org-wide aggregate on every plan mutation - only
    // an explicit manual refresh (see useOrgStats) invalidates it.
    getPlanStats: builder.query({
      query: () => ({
        url: "/plan/stats",
        method: "GET",
      }),
      providesTags: ["PlanStats"],
    }),
    getOrgBundlesWithPlans: builder.query({
      query: (params) => ({
        url: apiRoutes.plan.getBundlesWithPlans.path,
        method: apiRoutes.plan.getBundlesWithPlans.reqType,
        params,
      }),
      providesTags: ["PlanBundles"],
    }),
    getPlansWithBundleId: builder.query({
      query: (params) => ({
        url: "/plan/getPlansWithBundleId",
        method: "GET",
        params,
      }),
      providesTags: ["PlanBundles"],
    }),
    editPlan: builder.mutation({
      query: (data) => ({
        url: apiRoutes.plan.edit.path,
        method: apiRoutes.plan.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Plans", "PlanBundles"],
    }),
    archivePlan: builder.mutation({
      query: (data) => ({
        url: apiRoutes.plan.archive.path,
        method: apiRoutes.plan.archive.reqType,
        body: data,
      }),
      invalidatesTags: ["Plans", "PlanBundles"],
    }),
  }),
});

export const {
  useInitiatePlanMutation,
  useGetAllPlanQuery,
  useGetAllPlanByOrgIdQuery,
  useLazyGetAllPlanByOrgIdQuery,
  useGetPlanByIdQuery,
  useGetPlanStatsQuery,
  useGetOrgBundlesWithPlansQuery,
  useGetPlansWithBundleIdQuery,
  useEditPlanMutation,
  useArchivePlanMutation,
} = planApi;
